// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wGoQ","newExpiryDate":"styles_newExpiryDate__288AK","footer":"styles_footer__2Rdml"};